module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Expenses")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.$sessionsStorage.get('port_allModuleId') ?
        this.$sessionsStorage.get('port_allModuleId') :
        '',
      "jobSeriesBanner": this.$sessionsStorage.get('port_JOBSERIES') ?
        this.$sessionsStorage.get('port_JOBSERIES') :
        '',
      "bannerClientName": _vm.assignmentData[0].clientName ? _vm.assignmentData[0].clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 box-body mb-2 mr-1"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Assignment Details")])], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.assignmentData,
      "fields": _vm.assignmentfields,
      "per-page": _vm.assignmentperPage,
      "sort-by": _vm.assignmentsortBy,
      "sort-desc": _vm.assignmentsortDesc,
      "sort-direction": _vm.assignmentsortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.assignmentsortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.assignmentsortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "allModuleId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.assignmentcurrentPage - 1) * _vm.assignmentperPage))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 box-body mb-2"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Expense Document Details")])], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.ExpenseData,
      "fields": _vm.Expensefields,
      "per-page": _vm.ExpenseperPage,
      "sort-by": _vm.ExpensesortBy,
      "sort-desc": _vm.ExpensesortDesc,
      "sort-direction": _vm.ExpensesortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.ExpensesortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.ExpensesortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "exp_id",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.ExpensecurrentPage - 1) * _vm.ExpenseperPage))])]
      }
    }, {
      key: "exp_doc_link",
      fn: function(row1) {
        return [_c('h6', [(row1.item.exp_doc_link) ? _c('a', {
          staticStyle: {
            "color": "blue"
          },
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.assignmentData[0].Job_Series.replaceAll('/', '_')) + "/" + (row1.item.exp_doc_link.replaceAll('/', '_'))))
            }
          }
        }, [_c('b', [_c('u', [_vm._v(_vm._s("Doc " + parseInt(row1.index + 1)))])])]) : _vm._e()])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.addPortExpenseArray
    }
  }, [_vm._v("\n              Add Expenses "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._l((_vm.linePortExpenseArray), function(itm, idx) {
    return _c('b-card', {
      key: idx,
      staticClass: "mt-2"
    }, [(idx != 0) ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeInvArry(idx)
        }
      }
    }, [_vm._v("\n                  Remove Expenses "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e(), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      attrs: {
        "sm": "3"
      }
    }, [_c('label', [_vm._v("Invoice Type "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "multiple": "true",
        "isDisabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "list": _vm.$store.getters['commonDropdownMaster/getAllPortExpenseDDList'],
        "option-value": "documentTypeId",
        "option-text": "documentName",
        "placeholder": "Select Invoice Type"
      },
      model: {
        value: (itm.invType),
        callback: function($$v) {
          _vm.$set(itm, "invType", $$v)
        },
        expression: "itm.invType"
      }
    }), _vm._v(" "), (itm.invType_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invType_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "3"
      }
    }, [_c('label', [_vm._v("Invoice Amount "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "type": "number",
        "name": "InvoiceAmount",
        "id": "InvoiceAmount"
      },
      model: {
        value: (itm.invAmount),
        callback: function($$v) {
          _vm.$set(itm, "invAmount", $$v)
        },
        expression: "itm.invAmount"
      }
    }), _vm._v(" "), (itm.invAmount_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invAmount_err))]) : _vm._e(), _vm._v(" "), (itm.createdBy) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s("Created By : " + itm.createdBy + " Date Time " + itm.created_at))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "3"
      }
    }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "name": "shippingBillNo",
        "id": "shippingBillNo"
      },
      model: {
        value: (itm.invRemarks),
        callback: function($$v) {
          _vm.$set(itm, "invRemarks", $$v)
        },
        expression: "itm.invRemarks"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "3"
      }
    }, [_c('label', [_vm._v("Invoice Documents "), _c('span', {
      staticClass: "error"
    })]), _vm._v(" "), _c('Single-Upload', {
      attrs: {
        "index": idx,
        "multiple": false,
        "documentName": 'Expense_Port_Multiple_Doc-',
        "otherDocName": 'Expense_Port_Multiple_Doc-',
        "folderName": 'Expense',
        "accept": '*',
        "state": Boolean(itm.invSlineUpload),
        "assign_no": _vm.assignmentData[0].Job_Series,
        "fileAllModuleId": _vm.$sessionsStorage.get('port_allModuleId')
      },
      model: {
        value: (itm.invSlineUpload),
        callback: function($$v) {
          _vm.$set(itm, "invSlineUpload", $$v)
        },
        expression: "itm.invSlineUpload"
      }
    }), _vm._v(" "), (itm.invSlineUpload_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invSlineUpload_err))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.assign_no_series && itm.invSlineUpload) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + _vm.doc_path + "/" + (itm.invSlineUpload)))
        }
      }
    }, [_vm._v("--View Document")]) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [(_vm.linePortExpenseArray.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addPortExpenseDetail
    }
  }, [_vm._v("Save & Submit\n                ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1)], 2)])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c22318","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/ExpensesPort.vue
// module id = 2422
// module chunks = 0